// Values match queryOptions on https://www.npmjs.com/package/indeed-scraper

export const TERM_OPTIONS = [
    { key: "all", value:"all", text: "All Term Lengths"},
    { key: "temp", value:"temporary", text: "Temporary"},
    { key: "part", value:"parttime", text: "Part-time"},
    { key: "full", value: "fulltime", text: "Full-time"},
    { key: "coop", value:"internship", text: "Co-op"},
    { key: "contract", value:"contract", text: "Contract"},
    { key: "comm", value:"commission", text: "Commision"}
];
